import { render, staticRenderFns } from "./playlist-shell.vue?vue&type=template&id=0361b172&scoped=true&"
import script from "./playlist-shell.vue?vue&type=script&lang=js&"
export * from "./playlist-shell.vue?vue&type=script&lang=js&"
import style0 from "./playlist-shell.vue?vue&type=style&index=0&id=0361b172&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0361b172",
  null
  
)

export default component.exports